import { useTranslation } from 'react-i18next';
import { PlusWorkingDaysRequest, PlusWorkingDaysResponse, ServiceType, ServiceViewDetails } from '@lib/api-interface';
import { UsecaseButton } from '@lib/ui-components';
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { RestUsecaseClientService } from '@lib/common-sdk';

interface ClientCollectionRequestPickupCommonServiceDialogProps {
  row: ServiceViewDetails;
  reload: () => void;
}

export const AdditionalServicePickupDialog = (props: ClientCollectionRequestPickupCommonServiceDialogProps) => {
  const { t } = useTranslation();
  const row = props.row;
  const [nextWorkingDate, setNextWorkingDate] = React.useState<string>('');
  const currentDay = new Date().getUTCDate();
  const plusWorkingDaysQuery = useQuery(['plusWorkingDays', currentDay, 1, true], () =>
    RestUsecaseClientService.post<PlusWorkingDaysRequest, PlusWorkingDaysResponse>('time', 'plus-working-days', {
      days: 1,
      skipMonday: true,
    }),
  );

  React.useEffect(() => {
    setNextWorkingDate(plusWorkingDaysQuery.data?.date || '');
  }, [plusWorkingDaysQuery]);

  return (
    <UsecaseButton
      key={row.id}
      groupName='collection-request-client'
      useCaseName='createCollectionRequestByClient'
      buttonLabel={t('reportPickup')}
      color={'secondary'}
      variant={'contained'}
      dialogTitle={t('askForService')}
      isDisabled={!row.active || (row.serviceType === ServiceType.ADDITIONAL && row.constantCost)}
      dialogText={t('askForServiceDetails')}
      hiddenValues={{
        collectionDate: nextWorkingDate,
        serviceId: row.serviceId,
        type: 'PICKUP',
      }}
      onSaved={async () => props.reload()}
    />
  );
};
